import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  reelStop: {
    width: 2,
    height: "120px",
    position: "absolute",
    left: "50%",
    top: "50%",
    translate: "-50% -50%",
    background: theme.design.color.status.danger,
    borderRadius: "50%",
  },

  reel: {},

  prizeItemList: {
    display: "flex",
    gap: 16,

    [theme.breakpoints.down("sm")]: {
      gap: 8,
    },
  },

  prizeItem: {
    background: theme.design.color.surface.subtle,
    border: "1px solid",
    borderColor: theme.design.color.border.black,
    borderRadius: 8,
    padding: 13,
    boxShadow:
      theme.design.shadow.insetStrong,

    "& img": {
      width: 72,
      height: 72,
      borderRadius: 8,
      objectFit: "contain",
    },

    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: 48,
        height: 48,
      },
    },
  },
}));

export default styles;
